import { render, staticRenderFns } from "./functionUpdateDescription.vue?vue&type=template&id=7b49a294"
import script from "./functionUpdateDescription.vue?vue&type=script&lang=js"
export * from "./functionUpdateDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports